import { call, put, takeLatest } from 'redux-saga/effects';
import {
  getAllEventsAction,
  getAllEventsErrorAction,
  getAllEventsSuccessAction,
  getRoomsAndServicesAction,
  getRoomsAndServicesErrorAction,
  getRoomsAndServicesSuccessAction,
  getSpecificRoomAndMonthBookedIntervalsAction,
  getSpecificRoomAndMonthBookedIntervalsErrorAction,
  getSpecificRoomAndMonthBookedIntervalsSuccessAction,
  getSpecificRoomAndMonthCustomerDataAction,
  getSpecificRoomAndMonthCustomerDataErrorAction,
  getSpecificRoomAndMonthMyPendingEventsSuccessAction,
  sendBookingAction,
  sendBookingErrorAction,
  sendBookingSuccessAction,
} from '../../store/shared/make-reservation.store';
import { ApiResponse } from '../../api/request';
import { productListAPI, smartObjectAPI } from '../../api/provider/product/product-provider';
import {
  bookedIntervalAPI,
  eventListAPI,
  sendBookingAPI,
  updateReservationAPI,
} from '../../api/provider/booking/booking-provider';
import { authenticatedCall } from '../../utils/authenticated-call';


function* getRoomsAndServicesSaga() {
  try {
    const roomsAndServicesResponse: ApiResponse | null = yield call(productListAPI);
    const smartObjectResponse: ApiResponse | null = yield authenticatedCall(smartObjectAPI);
    const data = {
      roomAndServices: roomsAndServicesResponse?.data,
      smartObject:smartObjectResponse?.data
    }
    yield put(getRoomsAndServicesSuccessAction(data));
  } catch (error: any) {
    yield put(getRoomsAndServicesErrorAction(error.localizedMessage))
  }
}

function* getSpecificRoomAndMonthBookedIntervalsSaga(data: any) {
  try {
    const bookedIntervalResponse: ApiResponse | null = yield call(bookedIntervalAPI, data.payload);
    yield put(getSpecificRoomAndMonthBookedIntervalsSuccessAction({
      bookedIntervalResponse: bookedIntervalResponse,
      monthKey: data.payload.monthKey,
      reservation_id: data.payload.reservation_id ? data.payload.reservation_id : null,
      // user: data.payload.user
    }));
  } catch (error: any) {
    yield put(getSpecificRoomAndMonthBookedIntervalsErrorAction(error.localizedMessage))
  }
}

function* getSpecificRoomAndMonthCustomerDataSaga(data: any) {
  try {
    const bookedIntervalResponse: ApiResponse | null = yield call(bookedIntervalAPI, data.payload);
    const myPendingEventsResponse: ApiResponse | null = yield call(eventListAPI, data.payload, ['SENT']);
    yield put(getSpecificRoomAndMonthBookedIntervalsSuccessAction({
      bookedIntervalResponse: bookedIntervalResponse,
      monthKey: data.payload.monthKey,
      reservation_id: data.payload.reservation_id ? data.payload.reservation_id : null,
      // user: data.payload.user
    }));
    yield put(getSpecificRoomAndMonthMyPendingEventsSuccessAction({
      myPendingEventsResponse: myPendingEventsResponse,
      monthKey: data.payload.monthKey,
      reservation_id: data.payload.reservation_id ? data.payload.reservation_id : null
    }));
  } catch (error: any) {
    yield put(getSpecificRoomAndMonthCustomerDataErrorAction(error.localizedMessage))
  }
}

function* sendBookingSaga(data: any) {
  try {
    const updateReservation = data.payload.bookingId
    let postData : any = {
      notes: updateReservation ? data.payload.bookingNotes : data.payload.data.notes,
      interval: data.payload.data.customerEvents
    }
    if (data.payload.customerData) {
      postData.first_name = data.payload.customerData.first_name
      postData.last_name = data.payload.customerData.last_name
      postData.email = data.payload.customerData.email
      postData.phone_number = data.payload.customerData.phone_number
    }
    if (updateReservation) {
      yield authenticatedCall(updateReservationAPI, updateReservation, postData);
    } else {
      yield authenticatedCall(sendBookingAPI, postData);
    }
    yield put(sendBookingSuccessAction());
  } catch (error: any) {
    yield put(sendBookingErrorAction(error.localizedMessage))
  }
}

function* getAllEventsSaga(data: any) {
  try {
    const allEventsResponse: ApiResponse | null = yield authenticatedCall(eventListAPI, data.payload);
    yield put(getAllEventsSuccessAction({
      allEventsResponse: allEventsResponse,
      monthKey: data.payload.monthKey,
      room: data.payload.room
    }));
  } catch (error: any) {
    yield put(getAllEventsErrorAction(error.localizedMessage))
  }
}

export function* makeReservationSagas() {
  yield takeLatest(getRoomsAndServicesAction.type, getRoomsAndServicesSaga);
  yield takeLatest(getSpecificRoomAndMonthBookedIntervalsAction.type, getSpecificRoomAndMonthBookedIntervalsSaga);
  yield takeLatest(getSpecificRoomAndMonthCustomerDataAction.type, getSpecificRoomAndMonthCustomerDataSaga);
  yield takeLatest(sendBookingAction.type, sendBookingSaga);
  yield takeLatest(getAllEventsAction.type, getAllEventsSaga)
}
